import {ArrowUpRight,FileCheck2} from 'lucide-react';
import {legalRecords} from '../domain/legal-records';
import {protectNames} from '../i18n/auto-translate';
import '../styles/offices.css';
protectNames(legalRecords.flatMap(r=>[r.code,r.office==='Công ty Cổ phần Khách sạn Du lịch Hoàng Long'?r.office:'']));
export function LegalRecords(){
 return <div className="legal-records" id="giay-dang-ky">
  <h3 className="lr-title"><FileCheck2 size={18} aria-hidden="true"/>Giấy đăng ký hoạt động</h3>
  <div className="lr-grid">{legalRecords.map(r=><article className="lr-card" key={r.id} id={'dk-'+r.id}>
   <strong>{r.office}</strong>
   <span className="lr-kind">{r.kind}</span>
   <dl>
    <div><dt>{r.codeLabel}</dt><dd>{r.code}</dd></div>
    <div><dt>Đăng ký lần đầu</dt><dd>{r.first}</dd></div>
    {r.changeLabel&&<div><dt>{r.changeLabel}</dt><dd>{r.change}</dd></div>}
    <div><dt>Cơ quan cấp</dt><dd>{r.authority}</dd></div>
   </dl>
   <a href={r.image} target="_blank" rel="noopener noreferrer">Xem bản đã che thông tin cá nhân<ArrowUpRight size={14} aria-hidden="true"/></a>
  </article>)}</div>
  <p className="lr-note">Bản gốc được lưu nội bộ. Thông tin cá nhân của người đứng đầu và người đại diện đã được che.</p>
 </div>;
}
